<template style="background-color: #e9e9e9;">
  <div class="home">
    <div>
      <div class="" style="text-align: center">
        <img
            alt="logo"
            src="../assets/logo_quick_pay_2022.png"
        />
      </div>
<!--      <h1>Términos y Condiciones</h1>-->
      <div class="body">
        <h3>Términos y Condiciones</h3>
        <p>
          Bienvenido a las apps móviles de QuickPay. Te presentamos nuestros términos y
          condiciones de uso, los cuales también incluyen sus derechos y obligaciones, por lo que
          le pedimos leerlos detenidamente. Al utilizar el aplicativo QuickPay, usted acepta estar
          sujeto a estos términos y condiciones y a nuestra Política de Privacidad. Si no acepta
          estos Términos en su totalidad, no podrá acceder ni utilizar el aplicativo QuickPay.
          Nuestro aplicativo solo puede ser utilizado por una persona mayor de 18 años. Si no
          cumple con este requisito, no está autorizado a utilizar esta aplicación. Estos Términos
          son legalmente vinculantes y le recomendamos que guarde o capture una copia para
          referencia futura.
        </p>

        <h3>¿A quién pertenece QuickPay y cómo contactarlos?</h3>
        <p>
          El aplicativo QuickPay es de titularidad de EA Solution S.A.C. (QuickPay). Nos
          encontramos registrados con el RUC 206077870207 y nuestra oficina está ubicada en
          Av. Del Ejército 244, Dpto. 1403, Magdalena del Mar, Lima, Perú. Cuando decimos
          "nuestro" o "nosotros" en estos Términos, nos referimos a los datos mencionados. Si
          tiene alguna pregunta relacionada con estos Términos, envíenos un correo electrónico
          a <a href="mailto:info@quickpay.com.pe">info@quickpay.com.pe</a> o escríbanos a Av. Del Ejército 244, Dpto. 1403, Magdalena del Mar, Lima, Perú.
        </p>

        <h3>Acceso al aplicativo de QuickPay</h3>
        <p>
          Actualmente, el aplicativo QuickPay está a su disposición de forma gratuita y es exclusivo
          para su uso personal y no comercial. Esto significa que usted es la única persona que
          puede usar el aplicativo QuickPay usando sus datos de inicio de sesión y que no puede
          generar dinero utilizando el aplicativo QuickPay.
        </p>

        <h3>Política de uso aceptable</h3>
        <p>
          A continuación, describiremos las acciones que acepta no realizar cuando utiliza el
          Aplicativo QuickPay. Si sabemos o sospechamos que lo ha hecho o lo hará, podemos
          suspender o revocar su acceso al aplicativo QuickPay. Algunos de los artículos que se
          enumeran a continuación son ilegales y es posible que debamos divulgar su identidad,
          actividades y cualquier información de respaldo a las agencias policiales. No debe utilizar
          el aplicativo QuickPay (incluido algún contenido u otro material):
        </p>

        <ul>
          <li>En violación de cualquier ley;</li>
          <li>De manera fraudulenta o engañosa;</li>
          <li>Para cualquier fin comercial (incluido el suyo propio o de un tercero);</li>
          <li>Para dañar a cualquier persona;</li>
          <li>Para enviar spam o mensajes duplicados o no solicitados que infrinjan las leyes
            vigentes, o para procesar, enviar o almacenar información confidencial
            (incluidos, entre otros, contraseñas, detalles de inicio de sesión y secretos
            comerciales y otra información confidencial), material ilegal, virus, bombas de
            tiempo, caballos de Troya u otros códigos, archivos, scripts, agentes o programas
            dañinos o maliciosos;</li>
          <li>Para obtener acceso no autorizado o dañar nuestras redes o sistemas y/o
            interrumpir la integridad o el rendimiento del aplicativo QuickPay o los datos
            contenidos en él;</li>
          <li>Para copiar, alquilar, vender, arrendar, sublicenciar, distribuir, asignar o de otra
            manera transferir o gravar derechos a cualquier software propietario o de
            terceros que forme parte del aplicativo QuickPay;</li>
          <li>Para acceder o usar el aplicativo QuickPay con el fin de crear un producto o
            aplicativo competitivo del aplicativo QuickPay o cualquier software propietario
            o de terceros que forme parte del aplicativo QuickPay o copiar sus características
            o la interfaz de usuario;</li>
          <li>Para modificar, adaptar, descompilar, desensamblar, realizar ingeniería inversa
            o crear trabajos derivados del aplicativo QuickPay o cualquier software
            propietario o de terceros que forme parte del aplicativo QuickPay;</li>
          <li>Para reproducir o copiar cualquier contenido en el aplicativo QuickPay;</li>
          <li>Para eliminar, alterar u ocultar cualquier derecho de autor, marca registrada u
            otros avisos de propiedad que aparezcan en el aplicativo QuickPay;</li>
          <li>Usar el aplicativo QuickPay de una manera que sobrecargue, o que amenace la
            integridad, el rendimiento o la disponibilidad del aplicativo QuickPay; o</li>
          <li>De cualquier manera, no autorizada o en una forma que sea perjudicial para
            nuestros proveedores de aplicativos de terceros.</li>
        </ul>

        <p>
          Podemos hacer que los anuncios, chats u otros aplicativos de comunicación estén
          disponibles en los aplicativos de QuickPay. No estamos obligados a monitorear ningún
          texto, imagen, video, audio u otro contenido multimedia, software u otra información o
          material enviado por usted u otros usuarios en los aplicativos de QuickPay. Cualquier
          envío que realice debe cumplir con nuestros estándares de envío establecidos a
          continuación. Cualquier presentación o comunicación a los usuarios de los aplicativos
          QuickPay debe cumplir con los estándares de precisión, decencia y legalidad, que se
          aplicarán a nuestra discreción, actuando de manera razonable. En particular, usted
          garantiza que cualquier envío o comunicación es: FALTA LA INFORMACIÓN
        </p>

        <h3>Modificación a estos términos</h3>
        <p>
          Podemos actualizar nuestros términos en ocasiones. Si lo hacemos, se lo haremos saber.
          Si continúa usando el aplicativo QuickPay después de que le hayamos notificado una
          actualización es porque acepta la versión actualizada de estos Términos. Si no está de
          acuerdo con los Términos actualizados, deberá dejar de usar el aplicativo QuickPay. En
          algunos casos, se le puede solicitar que acepte los términos revisados al acceder al
          Aplicativo QuickPay y si no está de acuerdo, no se le permitirá utilizarlo.
        </p>

        <h3>Modificaciones al aplicativo de QuickPay</h3>
        <p>
          Podemos actualizar y cambiar el aplicativo QuickPay o su funcionalidad en ocasiones en
          respuesta a los cambios en las necesidades de nuestros usuarios y nuestras prioridades
          comerciales o por cualquier otra razón. También podemos suspender, retirar o restringir
          la disponibilidad de todo o parte del aplicativo QuickPay por razones comerciales y
          operativas. En lo posible, le avisaremos en un tiempo razonable cualquier cambio
          importante, suspensión o retiro.
        </p>

        <h3>Exactitud y no confianza en la información</h3>
        <p>
          Si bien realizamos esfuerzos razonables para actualizar la información del aplicativo
          QuickPay, cualquier información que le proporcionemos como parte de nuestros
          aplicativos es tan precisa, actualizada y completa como la información que recibimos de
          usted o de un tercero (incluidos minoristas y proveedores). No verificamos la exactitud
          o integridad de la información que recibimos de usted o de terceros, y no hacemos
          ninguna declaración o garantía, ya sea expresa o implícita, de que el contenido del sitio
          del aplicativo QuickPay sea exacto, completo o actualizado. Además, no somos
          responsables de la puntualidad, precisión o almacenamiento de cualquier información
          de usuario, comunicaciones o configuración de personalización y no podemos garantizar
          que el aplicativo QuickPay o cualquier contenido o funcionalidad provista como parte
          de nuestros aplicativos (incluida la capacidad de recuperar datos de artículos). Las
          funciones de escanear códigos de barras, pagar por artículos, buscar artículos relevantes
          de la tienda y otras funciones habilitadas para la nube, siempre estará disponible, sin
          interrupciones o sin errores. No garantizamos que el aplicativo QuickPay esté libre de
          errores o virus.
        </p>

        <h3>Propiedad del aplicativo QuickPay</h3>
        <p>
          Somos dueños o licenciamos todos los derechos de propiedad intelectual en el aplicativo
          QuickPay y en cualquier sistema de componentes. Todo el contenido del aplicativo
          QuickPay está sujeto a derechos de autor con todos los derechos reservados. Esto
          significa que no se le transfiere ningún título ni ningún derecho de propiedad intelectual
          y que, a menos que se indique a continuación, no puede copiar, reproducir imágenes,
          marcas comerciales, marcas o contenido sin permiso. Puede imprimir una copia, y puede
          descargar extractos, de cualquier página del Aplicativo QuickPay para su uso personal,
          sin embargo, no debe:
        </p>

        <ul>
          <li>
            Modificar el papel o las copias digitales de cualquier material que haya impreso
            o descargado de cualquier manera, y no debe usar y/o alterar parcial o
            completamente las ilustraciones, fotografías, secuencias de video o audio o
            gráficos; así como tampoco separar sus elementos;
          </li>
          <li>
            Eliminar cualquier reconocimiento de que nosotros o cualquiera de nuestros
            colaboradores es el autor de cualquier contenido que le proporcionamos como
            parte del aplicativo QuickPay.
          </li>
          <li>
            Utilizar cualquier parte del contenido del aplicativo QuickPay con fines
            comerciales sin obtener una licencia para hacerlo de parte nuestra o de nuestros
            licenciantes.
          </li>
        </ul>

        <p>
          Si imprime, copia o descarga cualquier parte del aplicativo QuickPay que incumple estos
          términos, su derecho a utilizarlo cesará de inmediato y deberá, a nuestra opción,
          devolver o destruir cualquier copia de los materiales que haya realizado. Usted es
          responsable de mantener seguro y de manera confidencial cualquier material que haya
          copiado, impreso o descargado. QuickPay no se hace responsable de las pérdidas
          resultantes de su falta de seguridad y confidencialidad de estos materiales, incluidas las
          pérdidas derivadas del acceso no autorizado a los materiales o al aplicativo QuickPay.
        </p>

        <h3>Descarga y uso del aplicativo</h3>
        <p>
          La aplicación podrá ser descargada desde las tiendas virtuales existentes para los
          diversos sistemas operativos. Una vez descargado el aplicativo el cliente podrá iniciar
          una operación previo registro con la información personal y financiera. El aplicativo
          adicionalmente solicitará acceso a ciertas funciones del dispositivo móvil tales como
          cámara y/o GPS, etc. relacionadas a su funcionamiento y objetivo.
        </p>

        <p>
          El cliente no tendrá límite en la cantidad de productos a adquirir con el aplicativo,
          sin embargo, por políticas propias de cada tienda comercial esta cantidad podría ser
          limitada. Una vez que termine la operación de compra y pago, se proporcionará un
          código QR que tendrá la información de los productos adquiridos y del pago ejecutado,
          con el cual podrá acercarse al módulo correspondiente para la validación de la compra,
          entrega de bolsas, de ser el caso, así como el retiro de los mecanismos de seguridad.
        </p>

        <p>
          El cliente recibirá en un plazo no mayor de 60 minutos, luego de finalizada la
          operación, la boleta electrónica respectiva al correo electronico registrado en el
          aplicativo. En caso el cliente cometa algún error en la operación, podrá requerir la
          anulación de la compra por medio de los canales de atención que pone a su disposición
          QuickPay.
        </p>

        <h3>Pago</h3>
        <p>
          Para realizar una compra, puede agregar información de la tarjeta de pago al
          aplicativo QuickPay. Debido a que utilizamos un proveedor de pasarela de pago de
          terceros para procesar sus pagos, no tendremos acceso a la información financiera;
          estos detalles serán recibidos directamente por nuestro proveedor. Solo recibiremos
          los últimos cuatro dígitos y la fecha de vencimiento de su tarjeta de pago con el fin de
          facilitar el registro de su tarjeta de pago en su perfil de usuario del aplicativo
          QuickPay. Almacenaremos esta información de manera segura de acuerdo con nuestra
          Política de Privacidad. Al proporcionar la información de su tarjeta de pago, usted
          autoriza todas las compras realizadas desde su dispositivo utilizando el aplicativo
          QuickPay. El uso de una tarjeta de pago puede estar sujeto a términos y condiciones
          separados entre usted y el emisor de la tarjeta, y no nos hacemos responsables por la
          falta de procesamiento de un pago. Si se realizan pagos no autorizados utilizando el
          aplicativo QuickPay, debe comunicarse de inmediato con el emisor de su tarjeta. Si ya
          no desea utilizar un método de pago en particular, hay una opción para eliminar la
          información de su tarjeta de pago en el aplicativo QuickPay. El uso que hagamos de
          su información de pago, así como de cualquier información compartida con el emisor
          de su tarjeta o un tercero, se regirá por nuestra Política de Privacidad.
        </p>

        <h3>Uso de datos móviles</h3>
        <p>
          Para funcionar correctamente, el Aplicativo QuickPay requiere una conexión a
          internet inalámbrica o a través de datos móviles. No nos hacemos responsables de la
          falta de disponibilidad del aplicativo QuickPay debido a una mala conectividad.
          Tenga en cuenta que su proveedor de aplicativos móviles puede cobrarle al acceder al
          aplicativo QuickPay. Todos los cargos incurridos son responsabilidad del usuario y
          están sujetos a los términos de su proveedor de aplicativos móviles. Si no es el
          pagador de facturas para el dispositivo en el que está utilizando el Aplicativo QuickPay,
          asumiremos que ha recibido el permiso del pagador de facturas y no somos
          responsables de ninguna falla de su parte para buscar tal permiso.
        </p>

        <h3>Tu información</h3>
        <p>
          Todos los datos personales que nos proporcione cuando se registre en el aplicativo
          QuickPay o que se recopilen a través del aplicativo QuickPay se procesarán de acuerdo
          con nuestra Política de Privacidad. Sus derechos y obligaciones en relación con el
          procesamiento de sus datos personales por QuickPay se describen en nuestra Política
          de Privacidad.
        </p>

        <h3>Sitios web y aplicaciones externas</h3>
        <p>
          El aplicativo QuickPay puede contener enlaces a otros sitios y recursos proporcionados
          por terceros. Estos enlaces se proporcionan solo para su información, a menos que
          se indique lo contrario. Dichos enlaces no deben interpretarse como aprobación por
          nosotros de los sitios web vinculados o la información que puede obtener de ellos y su
          acceso a dichos sitios web o la información puede regirse por términos y condiciones
          independientes de dichos terceros. No tenemos control sobre el contenido de esos
          sitios o recursos.
        </p>

        <h3>Nuestra responsabilidad</h3>
        <p>
          Lea esta sección detenidamente, ya que estos términos excluyen o limitan nuestra
          responsabilidad ante usted por cualquier pérdida sufrida por usted en relación con el
          uso del aplicativo QuickPay. Excepto por cualquier responsabilidad legal que no
          podamos excluir de la ley (como muerte o lesiones personales). QuickPay no es
          legalmente responsable por pérdidas que: (a) no fueron previsibles para usted y
          para nosotros cuando se formaron estos términos; o (b) que no fueron causadas por
          ningún incumplimiento de nuestra parte. Además, QuickPay no es responsable por
          pérdidas comerciales o pérdidas para los que no son consumidores. Se puede
          agregar: Tampoco somos responsables de la calidad de los productos y/o servicios
          adquiridos a través de nuestra plataforma en los diferentes comercios afiliados.
        </p>

        <h3>Terminando estos términos</h3>
        <p>
          Nos reservamos el derecho de rescindir estos términos y su uso del aplicativo QuickPay
          en cualquier momento, con o sin causa, inmediatamente después de que le
          notifiquemos por escrito a la dirección de correo electrónico que nos proporcionó
          cuando se registró en el aplicativo QuickPay. Como se explica más detalladamente en
          la Política de Privacidad, su acceso al aplicativo QuickPay se suspenderá o terminará
          si retira su consentimiento para el procesamiento de sus datos personales. Tenga en
          cuenta que podemos mantener registros que contengan sus datos personales de
          acuerdo con nuestra Política de Privacidad. Si ya no desea utilizar el aplicativo
          QuickPay, puede desinstalarlo de su dispositivo. La desinstalación del aplicativo
          QuickPay de su dispositivo terminará estos términos.
        </p>

        <h4>General</h4>
        <h3>Eventos fuera de nuestro control.</h3>
        <p>
          No somos responsables ante usted por cualquier
          retraso o incumplimiento de nuestras obligaciones en virtud de estos términos si el
          retraso o incumplimiento se debe a circunstancias que están fuera de nuestro control
          razonable.
        </p>

        <h3>Derechos de terceros</h3>
        <p>
          Estos términos son entre usted y nosotros. Ninguna otra persona tendrá derecho a
          hacer cumplir ninguno de estos términos.
        </p>

        <h3>Acuerdo completo</h3>
        <p>
          Estos términos (que incluyen nuestra Política de Privacidad) constituyen el acuerdo y
          la comprensión completos entre usted y nosotros en relación con su uso del aplicativo
          QuickPay.
        </p>

        <h3>Avisos</h3>
        <p>
          Usted acuerda que nosotros podemos enviar avisos o comunicaciones por correo
          electrónico o publicarse en el aplicativo QuickPay y que esto cumplirá con nuestro
          requisito de notificarle dichas comunicaciones por escrito. Usted acepta que cualquier
          comunicación realizada de esta manera se considerará recibida por usted 24 horas
          después del correo electrónico o publicación.
        </p>

        <h3>Disputas y ley aplicable</h3>
        <p>
          Los tribunales peruanos tendrán jurisdicción sobre cualquier reclamo que surja de, o
          esté relacionado con, cualquier uso del aplicativo QuickPay. Estos términos de uso y
          cualquier disputa o reclamo que surja de o en relación con ellos o su objeto o formación
          (incluidas las disputas o reclamos no contractuales) se regirán e interpretarán de
          acuerdo con las leyes de Perú.
        </p>


      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TermsConditions'
}

</script>
<style scoped>
  h3 {
    font-weight: bold;
    font-size: 17px;
  }
  h4{
    font-size: 21px;
    font-weight: bold;
  }
  h1{
    text-align: center;
    padding-bottom: 2%;
    font-weight: bold
  }
  p{
    text-align: justify;
  }
  .home{
    padding: 0 5% 0 5% ;
    max-width: 1366px;
    margin: 0 auto;
  }
  img{
    width: 20%
  }

  @media only screen and (max-width: 600px) {
    img {
      width: 50%
    }
    h1{
      font-size: 30px;
    }
    h3{
      font-size: 25px;
    }
  }

</style>
